import { Stack, SxProps, useTheme } from '@mui/material';
import { ComponentProps, PropsWithChildren } from 'react';

import { COLORS } from '@/styles/tokens/colors';

export interface SidebarContainerProps extends PropsWithChildren {
  /** Defaults to 16.67%, the equivalent of 2/12 columns. */
  width?: ComponentProps<typeof Stack>['width'];
  sx?: Omit<SxProps, 'width' | 'minWidth' | 'maxWidth' | 'flexBasis'>;
}

export const DEFAULT_SIDEBAR_WIDTH = '240px';

export function SidebarContainer({
  width = DEFAULT_SIDEBAR_WIDTH,
  sx = {},
  children,
  ...props
}: SidebarContainerProps) {
  const theme = useTheme();
  return (
    <>
      <Stack
        spacing={2}
        boxShadow={theme.palette.shadows.rightInvertInset}
        {...props}
        sx={{
          height: '100%',
          background: COLORS.PRIMITIVES.WHITE,
          overflowY: 'auto',
          flexGrow: 0,
          flexShrink: 0,
          ...sx,
          flexBasis: width,
          width: width,
          minWidth: width,
          maxWidth: width,
        }}
      >
        {children}
      </Stack>
    </>
  );
}
